import { ExperienceId, ActivitiesEntryTypeEnum, ENTRY_TYPE_TO_CODE } from "redmond";
import dayjs from "dayjs"; // eslint-disable-line import/no-extraneous-dependencies
import { History } from "history"; // eslint-disable-line import/no-extraneous-dependencies
/* eslint-disable import/no-unresolved, import/extensions -- resolved by webpack alias */
import {
  PATH_ACTIVITIES_AVAILABILITY,
  PATH_HOME,
} from "../constants/urlPaths";
/* eslint-enable import/no-unresolved, import/extensions */

export const CATEGORY_TAG_ID_PARAM = "categoryTagId";

const mergeAndStringifyEntryTypes = (
  entryType: ActivitiesEntryTypeEnum,
  entryTypes: ActivitiesEntryTypeEnum[]
): string => {
  const combined = [...entryTypes, entryType];
  const unique = Array.from(new Set(combined));

  const codes: (string | null)[] = unique.map(
    (type) => ENTRY_TYPE_TO_CODE[type] ?? null
  );

  // Type-safe null filter
  const validCodes = codes.filter((x): x is Exclude<typeof x, null> => x !== null);

  return validCodes.join("_");
}


export const getExperiencesAvailabilityQuery = (
  locationLabel: string,
  fromDate: Date | string | null,
  untilDate?: Date | string | null,
  categoryTagId?: number,
  isTravelApp?: boolean,
  entryType?: ActivitiesEntryTypeEnum,
  lodgingId?: string,
  staysAdvance?: number,
  entryTypesAll?: ActivitiesEntryTypeEnum[]
): string => {
  let query = `?locationName=${encodeURIComponent(locationLabel)}`;

  if (fromDate) {
    const formatFrom = dayjs(fromDate).format("YYYY-MM-DD");
    query += `&fromDate=${formatFrom}`;
  }

  if (untilDate) {
    const formatUntil = dayjs(untilDate).format("YYYY-MM-DD");
    query += `&untilDate=${formatUntil}`;
  }

  if (categoryTagId) {
    query += `&${CATEGORY_TAG_ID_PARAM}=${categoryTagId}`;
  }
  if (isTravelApp) {
    query += `&isTravelApp=true`;
  }

  if (entryType != null) {
    const serialized = entryTypesAll != null && entryTypesAll.length > 0
      ? mergeAndStringifyEntryTypes(entryType, entryTypesAll)
      : ENTRY_TYPE_TO_CODE[entryType] ?? "0";
    query += `&entryType=${serialized}`;
  }

  if (lodgingId) {
    query += `&lodgingId=${encodeURIComponent(lodgingId)}`;
  }

  if (staysAdvance !== undefined) {
    query += `&staysAdvance=${staysAdvance}`;
  }

  return query;
};

export const getExperiencesShopQuery = (
  experienceId: ExperienceId,
  fromDate: Date | null,
  untilDate: Date | null,
  locationLabel?: string | null,
  isTravelApp?: boolean,
  index?: number,
  entryType?: ActivitiesEntryTypeEnum,
  entryTypesAll?: ActivitiesEntryTypeEnum[],
  lodgingId?: string,
  staysAdvance?: number
): string => {
  const experienceIdString = encodeURIComponent(experienceId.value);

  let query = `?activityId=${experienceIdString}`;

  if (fromDate) {
    const formatFrom = dayjs(fromDate).format("YYYY-MM-DD");
    query += `&fromDate=${formatFrom}`;
  }

  if (untilDate) {
    const formatUntil = dayjs(untilDate).format("YYYY-MM-DD");
    query += `&untilDate=${formatUntil}`;
  }

  if (locationLabel) {
    query += `&locationName=${encodeURIComponent(locationLabel)}`;
  }
  if (isTravelApp) {
    query += `&isTravelApp=true`;
  }
  if (index !== undefined) {
    query += `&index=${index}`;
  }

  if (entryType !== undefined) {
    const serializedEntryTypesAll = mergeAndStringifyEntryTypes(entryType, entryTypesAll ?? []);
    query += `&entryType=${serializedEntryTypesAll}`;
  }

  if (lodgingId) {
    query += `&lodgingId=${encodeURIComponent(lodgingId)}`;
  }

  if (staysAdvance !== undefined) {
    query += `&staysAdvance=${staysAdvance}`;
  }

  return query;
};

export const goToExperiencesAvailability = ({
  history,
  locationLabel,
  fromDate,
  untilDate,
  isTravelApp,
}: {
  history: History;
  locationLabel: string | null;
  fromDate: Date | null;
  untilDate: Date | null;
  isTravelApp?: boolean;
}) => {
  if (!locationLabel) {
    return history.push(PATH_HOME);
  }

  return history.push(
    `${PATH_ACTIVITIES_AVAILABILITY}${getExperiencesAvailabilityQuery(
      locationLabel,
      fromDate,
      untilDate,
      undefined,
      isTravelApp
    )}`
  );
};
